/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation VendorDeleteMutation($vendorId: ID!) {
    VendorDelete(vendorId: $vendorId) {
        message
        status
    }
} 
`

